import { ReactNode } from 'react';
import cn from '../../../../utils/classnames';

type ModalBodyProps = {
    children: ReactNode;
    className?: string;
};

const ModalBody = ({ children, className }: ModalBodyProps) => {
    return <div className={cn('modal-body', className)}>{children}</div>;
};

export default ModalBody;
